import { DashHeader } from '/src/components/headers/DashHeader';
import { DashboardPage } from '/src/components/Page';
import { getFeatureName } from '/src/features/_global/utils';
import { useAuthContext } from '/src/hooks';

import { TrialExpiredPaywall } from '/src/features/_global/paywalls/TrialExpiredPaywall';
import { SubscriptionCancelledPaywall } from '/src/features/_global/paywalls/SubscriptionCancelledPaywall';
import { SubscriptionExpiredPaywall } from '/src/features/_global/paywalls/SubscriptionExpiredPaywall';
import { TrialCCFailedPaywall } from '/src/features/_global/paywalls/TrialCCFailedPaywall';

import { LiveUpgradePaywall } from '/src/features/live-activity/components/paywalls/LiveUpgradePaywall';
import { SnapshotsUpgradePaywall } from '/src/features/snapshots/paywalls/SnapshotsUpgradePaywall';
import { SnapshotsUpsellPaywall } from '/src/features/snapshots/paywalls/SnapshotsUpsellPaywall';
import { RecordingsUpgradePaywall } from '/src/features/recordings/components/dashboard/paywalls/RecordingsUpgradePaywall';
import { RecordingsUpsellPaywall } from '/src/features/recordings/components/dashboard/paywalls/RecordingsUpsellPaywall';
import { GoalsUpgradePaywall } from '/src/features/goals/paywalls/GoalsUpgradeWall';
import { ABTestingUpgradePaywall } from '/src/features/ab-testing/components/paywalls/ABTestingUpgradePaywall';
import { ABTestingUpsellPaywall } from '/src/features/ab-testing/components/paywalls/ABTestingUpsellPaywall';
import { TAUpgradePaywall } from '/src/features/traffic-analysis/components/paywalls/TAUpgradePaywall';
import { TAUpsellPaywall } from '/src/features/traffic-analysis/components/paywalls/TAUpsellPaywall';
import { ErrorsUpgradePaywall } from '/src/features/errors/components/paywalls/ErrorsUpgradePaywall';
import { ErrorsUpsellPaywall } from '/src/features/errors/components/paywalls/ErrorsUpsellPaywall';
import { AddonsUpgradePaywall } from '/src/features/addons/paywalls/AddonsUpgradeWall';
import { SurveysUpgradePaywall } from '/src/features/addons/paywalls/SurveysUpgradeWall';
import { CTAsUpgradePaywall } from '/src/features/addons/paywalls/CTAsUpgradeWall';
import { CTAsUpsellPaywall } from '/src/features/addons/paywalls/CTAsUpsellPaywall';
import { FunnelsUpsellPaywall } from '../../funnels/components_v2/paywalls/FunnelsUpsellPaywall';
import { CAPABILITY_REASONS, FEATURES, SUBSCRIPTION_STATES, PLAN_TYPES } from '/src/features/_global/constants';

export function DashboardPaywall({ feature, reason, mini, contentOnly, paddingLeftRight = '25%' }) {
  const { subscription } = useAuthContext();

  function renderPaywall() {
    switch (reason) {
      case CAPABILITY_REASONS.SUBSCRIPTION_ISSUE:
        {
          switch (subscription.state) {
            case SUBSCRIPTION_STATES.EXPIRED:
              {
                switch (subscription.plan.type) {
                  case PLAN_TYPES.TRIAL:
                    return <TrialExpiredPaywall />;
                  case PLAN_TYPES.PAID:
                    return <SubscriptionExpiredPaywall />;
                }
              }
              break;
            case SUBSCRIPTION_STATES.CANCELED:
              return <SubscriptionCancelledPaywall />;
            case SUBSCRIPTION_STATES.TRIAL_CC_FAILED:
              return <TrialCCFailedPaywall />;
            case SUBSCRIPTION_STATES.INACTIVE:
              // TODO for Zombie Freemium
              return;
          }
        }
        break;
      case CAPABILITY_REASONS.UPGRADE: {
        switch (feature) {
          case FEATURES.LIVE_ACTIVITY:
            return <LiveUpgradePaywall mini={mini} />;
          case FEATURES.SNAPSHOTS:
            return mini ? <SnapshotsUpgradePaywall mini={mini} /> : <SnapshotsUpsellPaywall />;
          case FEATURES.RECORDINGS:
            return mini ? <RecordingsUpgradePaywall mini={mini} /> : <RecordingsUpsellPaywall />;
          case FEATURES.GOALS:
            return <GoalsUpgradePaywall mini={mini} />;
          case FEATURES.AB_TESTING:
            return mini ? <ABTestingUpgradePaywall mini={mini} /> : <ABTestingUpsellPaywall />;
          case FEATURES.TRAFFIC_ANALYSIS:
            return mini ? <TAUpgradePaywall mini={mini} /> : <TAUpsellPaywall />;
          case FEATURES.ERRORS_TRACKING:
            return mini ? <ErrorsUpgradePaywall mini={mini} /> : <ErrorsUpsellPaywall />;
          case FEATURES.ADDONS:
            return <AddonsUpgradePaywall mini={mini} />;
          case FEATURES.SURVEYS:
            return <SurveysUpgradePaywall mini={mini} />;
          case FEATURES.CTAS:
            return mini ? <CTAsUpgradePaywall mini={mini} /> : <CTAsUpsellPaywall />;
          case FEATURES.FUNNELS:
            return <FunnelsUpsellPaywall />;
        }
      }
    }
    return null;
  }

  if (mini || contentOnly) return renderPaywall();

  return (
    <DashboardPage>
      <DashHeader title={getFeatureName(feature)} />
      <div style={{ padding: `0 ${paddingLeftRight}` }}>{renderPaywall()}</div>
    </DashboardPage>
  );
}
